import {qs, createEl} from "../utils/dom.js";
import {appState} from "../state/app-state.js";
import {navigateToOffer} from "../utils/navigation.js";
import {siteName} from "../utils/url.js";

export function renderTopCasino() {
    const mount = qs("#top-casino");
    if (!mount) {
        return;
    }

    const hasOffers =
        !!appState.website &&
        Array.isArray(appState.website.offers) &&
        appState.website.offers.length > 0;

    mount.innerHTML = "";

    const country = appState.website?.website?.country_name;
    const h2 = createEl("h2", {
        className: "title-black topCasinoSection_title",

        text: hasOffers && country ? `Top Casinos ${country}` : "Top Casinos",
    });

    const grid = createEl("div", {className: "cards"});

    function renderCards(visibleCount) {
        grid.innerHTML = "";

        appState.website.offers.slice(0, visibleCount).forEach((offer) => {
            const card = createEl("div", {className: "cardCasino"});
            const img = createEl("img");

            img.src = `https://panvfg.com/images/offers/${offer.logo}`;
            img.alt = `${offer.name} in ${siteName}`;
            img.title = `${offer.name} in ${siteName}`;
            img.width = 190;
            img.height = 76;
            img.loading = "lazy";
            img.onerror = function () {
                this.src = "./public/images/casino-placeholder.webp";
            };

            const p = createEl("p", {
                className: "offer",
                text:
                    offer.bonuses && offer.bonuses.welcome_bonus
                        ? offer.bonuses.welcome_bonus
                        : "",
            });

            const btn = createEl("a", {className: "button-secondary", attrs: {href: `casino/${offer.id}`}});
            btn.textContent = "Claim bonus";
            btn.addEventListener("click", (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                navigateToOffer(offer.id, offer.link);
            });

            card.addEventListener("click", () => {
                navigateToOffer(offer.id, offer.link);
            });

            card.appendChild(img);
            card.appendChild(p);
            card.appendChild(btn);
            grid.appendChild(card);
        });
    }

    const visibleCount = 8;
    if (hasOffers) {
        renderCards(visibleCount);
    }

    mount.appendChild(h2);
    mount.appendChild(grid);
}
